export default function CatalogEntryOptionalDetailsPanel({ entry }) {
  const rows = [];

  if (entry?.metadata?.ux?.estimatedDurationMinutes) {
    rows.push({
      label: "Estimated duration",
      value: `${entry.metadata.ux.estimatedDurationMinutes} min`
    });
  }

  if (entry?.metadata?.ux?.numberOfTasks !== undefined &&
      entry?.metadata?.ux?.numberOfTasks !== null) {
    rows.push({
      label: "Number of tasks",
      value: String(entry.metadata.ux.numberOfTasks)
    });
  }

  if (rows.length === 0) {
    return null;
  }

  return (
    <section className="catalog-detail__panel">
      <h2>Details</h2>

      <dl>
        {rows.map((row) => (
          <div key={row.label}>
            <dt>{row.label}</dt>
            <dd>{row.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
